import React from 'react';
import Layout from '../src/components/layout/_layout';
import SEO from '~/components/seo';
import { Trans, withI18n } from '@lingui/react';
import { SectionContainer } from '~/styles/common';
import styled from 'styled-components';
import TheStory from '~/components/about-us/theStory';
import MissionVision from '~/components/about-us/missionVision';
import FadeInSection from '~/components/fadeinSection';

const pageSections = [<MissionVision />, <TheStory />];

const About = () => {
    return (
        <Layout welcome={false}>
            <SEO title="global.menu.link.about" />
            <Heading>
                <Trans id="global.menu.link.about" />
            </Heading>

            {pageSections.map((section, id) => {
                return <FadeInSection key={id}>{section}</FadeInSection>;
            })}
        </Layout>
    );
};

const Heading = styled.div`
    font-weight: bold;
    font-size: 2.5rem;
    text-align: center;
    letter-spacing: -1px;
    color: #0cc8a8;
    margin-top: 24px;
`;

const Heading2 = styled(Heading)`
    margin-top: 60px;
    color: red;
    font-size: 50px;
`;

const AboutSectionContainer = styled(SectionContainer)`
    padding-top: 30px;
    background: white;
`;

export default withI18n()(About);
